import { BASE_URL } from "../config/api";

export const createNews = async (formData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/news/createNews`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to create News.");
  }

  return result;
};


export const fetchAllNews = async () => {
  const response = await fetch(`${BASE_URL}/news/fetchAllNews`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch blogs");
  }

  const data = await response.json();
  return data.news; // Assuming API returns { blogs: [...] }
};

export const fetchAllNewsWithAuthors = async () => {
  const response = await fetch(`${BASE_URL}/news/fetchAllNewsWithAuthors`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch blogs");
  }

  const data = await response.json();
  return data.news; // Assuming API returns { blogs: [...] }
};

export const fetchNewsWithAuthorById = async (id) => {
  const response = await fetch(`${BASE_URL}/news/fetchNewsWithAuthorById/${id}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch News");
  }

  return await response.json();
};

export const updateNews = async (id, formData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/news/updateNews/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to update news.");
  }

  return result;
};